import React from 'react';
import PerformanceComment from 'src/models/PerformanceComment';
import moment from 'moment';
import PropertyUtil from 'src/util/PropertyUtil';
import Button from '../../controls/forms/redesign/FormButton';

interface ICommentListProps {
    performanceComments: Array<PerformanceComment>;
    onEditCommentClick: (comment: PerformanceComment) => void;
    updatePerformanceComment: (comment: PerformanceComment) => void;
    deletePerformanceComment: (comment: PerformanceComment) => void;
}

class CommentList extends React.Component<ICommentListProps> {
    onApproveCommentClick = (comment: PerformanceComment) => {
        comment.isApproved === false ? (comment.isApproved = true) : (comment.isApproved = false);
        this.props.updatePerformanceComment(comment);
    };

    onEditCommentClick = (comment: PerformanceComment) => {
        this.props.onEditCommentClick(comment);
    };

    onDeleteCommentClick = (comment: PerformanceComment) => {
        this.props.deletePerformanceComment(comment);
    };

    public render() {
        const comments = PropertyUtil.SafeGet(() => this.props.performanceComments);
        if (comments !== undefined) {
            comments.sort((a: PerformanceComment, b: PerformanceComment) => {
                const aDate = new Date(a.commentDate).getTime();
                const bDate = new Date(b.commentDate).getTime();
                return bDate - aDate;
            });
        }
        if (!comments) {
            return (
                <div>
                    <div className="no-data">
                        <span>No Comments Are available.</span>
                    </div>
                    <div className="loader">
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            );
        } else {
            return comments
                ? comments.map((comment: PerformanceComment) => {
                      return (
                          <div className="perf-comment-wrapper" key={comment.id}>
                              <div className="perf-comment">
                                  <div className={comment.isApproved ? 'perf-comment-header' : 'perf-comment-not-approved-header'}>
                                      {moment(comment.commentDate).format('LLL') +
                                          ' ' +
                                          ' by ' +
                                          comment.authorFirstName +
                                          ' ' +
                                          comment.authorLastName}
                                      <div>
                                          {comment.isEdited ? 'Edited by ' + comment.editAuthorFirstName + ' ' + comment.editAuthorLastName : ''}
                                      </div>
                                      <div className="button-row">
                                          <Button
                                              size="medium"
                                              intent="primary comment-button"
                                              text={comment.isApproved ? 'Unapprove' : ' Approve  '}
                                              onClick={() => this.onApproveCommentClick(comment)}
                                          />
                                          <Button
                                              size="medium"
                                              intent="primary comment-button"
                                              text="Edit"
                                              onClick={() => this.onEditCommentClick(comment)}
                                              disabled={comment.isApproved}
                                          />
                                          <Button
                                              size="medium"
                                              intent="primary comment-button"
                                              text="Delete"
                                              onClick={() => this.onDeleteCommentClick(comment)}
                                              disabled={comment.isApproved}
                                          />
                                      </div>
                                  </div>
                                  <div className="perf-comment-text"> {comment.commentText}</div>
                              </div>
                          </div>
                      );
                  })
                : undefined;
        }
    }
}

export default CommentList;



// WEBPACK FOOTER //
// ./src/components/personnel/components/CommentList.tsx